/**
 * Finding all `aui-blanket` elements on the page and check if they are all hidden.
 */
export const isLegacyAuiBlanketClosed = (): boolean => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const elBlankets = document.querySelectorAll('.aui-blanket');

	if (elBlankets.length === 0) {
		// no aui-blanket in DOM, so it means it's closed
		return true;
	}

	const isAllHidden = Array.from(elBlankets || []).every((el) => {
		if (
			el.getAttribute('aria-hidden') === 'true' ||
			// when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
			el.getAttribute('hidden') !== null
		) {
			return true;
		}

		return false;
	});

	return isAllHidden;
};
